/* The review form, lifted from the single-file build.
 *
 * Every control keeps its id, because that is the contract with the engine:
 * onAnalysisSubmit reads document.getElementById('lob').value and a dozen
 * siblings, and the dropzone handlers are bound by id. The class names are
 * the original stylesheet's for the same reason.
 *
 * The one change is onSubmit, which React needs; the engine's own submit
 * handler still runs, via App.
 */
export default function ReviewForm({ onSubmit }) {
  return (
    <aside className="app-sidebar" id="sidebar">
      <form id="analysisForm" autoComplete="off" onSubmit={onSubmit}>
        {/* 1. Line of Business */}
        <div className="form-group">
          <label htmlFor="lob" className="required">Line of Business</label>
          <select id="lob" defaultValue="" required>
            <option value="">— Select —</option>
            <option value="pc">Property &amp; Casualty</option>
            <option value="eb">Employee Benefits</option>
          </select>
        </div>

        {/* 2. Review Type */}
        <div className="form-group">
          <label htmlFor="reviewType" className="required">Review Type</label>
          <select id="reviewType" required>
            <option value="">— Select —</option>
            <option value="quickscreen">Quick Screen — Instant Pass/Fail</option>
            <option value="bor">BOR Analysis — Comprehensive Coverage Review</option>
          </select>
        </div>

        {/* 3. Case Nickname */}
        <div className="form-group">
          <label htmlFor="caseNick">Case Nickname</label>
          <input type="text" id="caseNick" placeholder="e.g., Sunrise ISD 2026 Renewal" />
        </div>

        {/* 4. Incumbent Carrier / Broker */}
        <div className="form-group">
          <label htmlFor="incumbent">Incumbent Carrier / Broker</label>
          <input type="text" id="incumbent" placeholder="e.g., Glatfelter / USI Insurance" />
        </div>

        {/* 5. Policyholder Name */}
        <div className="form-group">
          <label htmlFor="policyholderName" className="required">Policyholder Name</label>
          <input type="text" id="policyholderName" required placeholder="e.g., Sunrise Independent School District" />
        </div>

        {/* 6. Website URL */}
        <div className="form-group">
          <label htmlFor="websiteUrl">Website URL</label>
          <input type="text" id="websiteUrl" placeholder="e.g., https://www.sunriseisd.org" />
        </div>

        {/* Auto-detection notice (replaces State + Vertical user inputs) */}
        <div className="form-group">
          <div className="help-text" style={{background: '#faf9ff', border: '1px solid #e3e0f5', borderRadius: '4px', padding: '8px 10px'}}>
            🔎 <strong>Industry vertical(s) and state(s) are auto-detected</strong> from the uploaded policy documents and the organization/website overview — no manual entry. Every detected item is evidence-grounded and shown in the report.
          </div>
        </div>

        {/* 7. State(s) — AUTO-DETECTED (hidden; populated programmatically) */}
        <div className="form-group" style={{display: 'none'}}>
          <label htmlFor="states">State(s)</label>
          <input type="text" id="states" />
        </div>

        {/* 8. Industry Vertical — AUTO-DETECTED (hidden; populated programmatically) */}
        <div className="form-group" style={{display: 'none'}}>
          <label htmlFor="vertical">Industry Vertical</label>
          <input type="text" id="vertical" list="verticalList" />
          <datalist id="verticalList">
            {/* Education */}
            <option value="Charter School">
            </option><option value="Public School District">
            </option><option value="Private School">
            </option><option value="Higher Education">
            </option><option value="Vocational/Trade School">
            </option><option value="Early Childhood/Daycare">
    </option><option value="Tutoring &amp; Test Prep Services">
    </option><option value="Online Education Services">
    </option><option value="Education Services">
            {/* Healthcare */}
            </option><option value="Hospital/Health System">
            </option><option value="Medical Practice">
            </option><option value="Dental Practice">
            </option><option value="Behavioral Health">
            </option><option value="Home Health">
            </option><option value="Long-Term Care/Nursing">
            </option><option value="Ambulatory Surgery Center">
            {/* Energy & Industrial */}
            </option><option value="Oil &amp; Gas Exploration">
            </option><option value="Oil &amp; Gas Services">
    </option><option value="Oil &amp; Gas Services Supplier">
    </option><option value="Oilfield Equipment Supplier">
    </option><option value="Industrial Lifting &amp; Rigging">
    </option><option value="Wire Rope &amp; Sling Manufacturing">
            </option><option value="Renewable Energy">
            </option><option value="Battery Storage &amp; Distributed Energy">
            </option><option value="Retail Electricity Provider">
            </option><option value="Mining">
            </option><option value="Utilities">
            {/* Entertainment & Hospitality */}
            </option><option value="Venues/Arenas">
            </option><option value="Restaurants/Bars">
            </option><option value="Hotels/Resorts">
            </option><option value="Amusement Parks">
            </option><option value="Event Planning">
            </option><option value="Sports/Recreation">
            {/* Financial Services */}
            </option><option value="Private Equity">
            </option><option value="Banking">
            </option><option value="Insurance">
            </option><option value="Investment Advisory">
            </option><option value="Fintech">
            {/* Construction */}
            </option><option value="Construction">
            </option><option value="Construction — General Contractor">
            </option><option value="Construction — Specialty Trade">
            </option><option value="Construction — Heavy/Highway">
            </option><option value="Construction — Residential Builder">
            </option><option value="Construction — Subcontractor">
            </option><option value="Construction — Design-Build">
            </option><option value="Construction Consulting / A/E/C">
            {/* Real Estate */}
            </option><option value="Commercial Real Estate">
            </option><option value="Residential Development">
            </option><option value="Property Management">
            {/* Technology */}
            </option><option value="SaaS/Software">
            </option><option value="Hardware Manufacturing">
            </option><option value="IT Services/MSP">
            </option><option value="Cybersecurity">
            </option><option value="Telecommunications">
            {/* Transportation & Logistics */}
            </option><option value="Trucking/Fleet">
            </option><option value="Aviation">
            </option><option value="Maritime">
            </option><option value="Warehousing/Distribution">
            </option><option value="Freight Broker">
            </option><option value="Last Mile Delivery">

            {/* Manufacturing */}
            </option><option value="Food/Beverage Manufacturing">
            </option><option value="Pharmaceutical Manufacturing">
            </option><option value="Chemical Manufacturing">
            </option><option value="General Manufacturing">
            </option><option value="Automotive Manufacturing">
            </option><option value="Electronics Manufacturing">
            </option><option value="Industrial Processing">
            {/* Healthcare (additional) */}
            </option><option value="Telemedicine Provider">
            </option><option value="Clinical Laboratory">
            {/* Professional Services */}
            </option><option value="Law Firm">
            </option><option value="Accounting Firm">
            </option><option value="Architecture/Engineering">
            </option><option value="Consulting">
            </option><option value="Staffing/HR">
            {/* Nonprofit & Government */}
            </option><option value="501(c)(3) Nonprofit">
            </option><option value="Religious Organization">
            </option><option value="Municipal Government">
            </option><option value="Tribal Nation">
            </option><option value="Public Authority">
            {/* Rental / Leasing */}
            </option><option value="Equipment Rental">
            </option><option value="Heavy Equipment Rental">
            </option><option value="Tool & Equipment Leasing">
            {/* Agriculture */}
            </option><option value="Farming/Ranching">
            </option><option value="Agribusiness">
            </option><option value="Forestry">
            {/* Healthcare (additional) */}
            </option><option value="Veterinary / Animal Hospital">
            {/* Real Estate (additional) */}
            </option><option value="HOA / Community Association">
            </option><option value="Self-Storage Facility">
            {/* Entertainment & Hospitality (additional) */}
            </option><option value="Catering">
            {/* Other */}
            </option><option value="Other">
          </option></datalist>
        </div>

        {/* 9. Organization Mission/Overview */}
        <div className="form-group">
          <label htmlFor="orgOverview">Organization Mission / Overview</label>
          <textarea id="orgOverview" placeholder="Paste or auto-fetch organization overview..."></textarea>
          <button type="button" className="btn btn-accent btn-sm" id="autoFetchBtn" style={{marginTop: '6px', width: '100%'}}>
            ⚡ Auto-Fetch Organization Info &amp; Detect States
          </button>
        </div>

        {/* 10. Upload Policy Documents */}
        <div className="form-group">
          <label>Upload Policy Documents</label>
          <div className="upload-zone" id="uploadZone">
            <div className="upload-icon">📄</div>
            <p>Drag &amp; drop files here or <strong>click to browse</strong></p>
            <p style={{fontSize: '10px', marginTop: '4px'}}>PDF, DOC, DOCX, XLS, XLSX accepted</p>
          </div>
          <input type="file" id="fileInput" multiple accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt" style={{display: 'none'}} />
          <div className="file-list" id="fileList"></div>
          <div className="data-privacy-notice">
            <strong>⚠️ DATA PRIVACY:</strong> Do NOT upload documents containing Protected Health Information (PHI), Social Security Numbers, or any personally identifiable information (PII). SentriPol does not retain, store, or transmit any uploaded documents. All files are processed locally in your browser and are permanently deleted when this session ends or when you click "Start New Review."
          </div>
        </div>

        {/* Generate Button */}
        <button type="submit" className="btn btn-primary" id="generateBtn" style={{marginTop: '6px'}}>
          🔍 Generate Comprehensive Analysis
        </button>

      </form>
    </aside>
  );
}
